// src/pages/Solutions.js
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutSection from '../components/AboutSection';
import OurValuesSection from '../components/OurValuesSection';
import OurTeamSection from '../components/OurTeamSection';
import ToContactSection from '../components/ToContectSection';

const About = () => {
  return (
    <div>
      <Header />
      <AboutSection />
      <OurValuesSection />
      <OurTeamSection />
      <ToContactSection />
      <Footer/>
    </div>
  );
};

export default About;
